
const QrcodeLoading = () => {
	return (
		<>
			<div className={`qrcode-image-loading`}>
				<div></div>
			</div>
			<p style={{ textAlign: "center", fontSize: "12px"}}>
           <b> Please wait</b>
      </p>
		</>
	)
}

export default QrcodeLoading